<template>
  <div class="mf-card chart-container">
    <div v-if="!isPdf" class="container-header">
      <span class="pa-1 table-card-title"> Cidades </span>
      <div class="header-actions">
        <todos :disabled="Boolean(infoCidade.length)" :tipo-pessoa="tipoPessoa" :clientes-nao-resolvidos="notResolvedClients" />
        <export-data :data-fetcher="getDataToExport" filename="perfil_demografico_cidades" ghost />
      </div>
    </div>
    <mf-loading :loader="['last-update', 'primeiro-registro', 'cidade-fisica', 'cidade-juridica', 'geo-status']" :width="4" :height="70" loader-type="table">
      <v-container v-if="infoCidade.length" fluid class="pa-0" fill-height>
        <v-layout align-start wrap>
          <v-flex xs12 md6>
            <data-card :info-cidade="infoCidade" :tipo-pessoa="tipoPessoa" :is-pdf="isPdf" />
            <p
              v-if="!$wait.is(['last-update', 'primeiro-registro', 'cidade-fisica', 'cidade-juridica', 'geo-status']) && infoCidade.length && !isPdf"
              class="px-4 ma-0 caption secondary-text"
            >
              {{ notResolvedClients | localeString(0) }} clientes não resolvidos
            </p>
          </v-flex>
          <v-flex xs12 md6>
            <chart :array="infoCidade" label-property-name="DES_CIDADE_SN" data-property-name="NUM_CLIENTES_CADASTRADOS" />
          </v-flex>
        </v-layout>
      </v-container>
      <v-container v-else class="my-6">
        <v-row align="center">
          <v-col align="center">
            <span class="subtitle">Nenhum resultado encontrado</span>
          </v-col>
        </v-row>
      </v-container>
    </mf-loading>
  </div>
</template>

<script>
import orderBy from 'lodash/orderBy'
import DataCard from '@/modules/clientes/perfil-demografico/views/pages/CidadeDataTable.vue'
import Chart from '@/modules/clientes/perfil-demografico/views/pages/PerfilDemograficoChart.vue'
import Todos from '@/modules/clientes/perfil-demografico/views/pages/CidadesTodos.vue'
import { mapState } from 'vuex'

export default {
  components: {
    DataCard,
    Chart,
    Todos,
    ExportData: () => import('@/components/export-data/ExportData.vue'),
  },
  props: {
    tipoPessoa: String,

    isPdf: {
      type: Boolean,
      default: false,
    },

    notResolvedClients: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    ...mapState({
      stateInfoCidadeFisica: (state) => state.clientes.perfilDemograficoCidadeFisica,
      stateInfoCidadeJuridica: (state) => state.clientes.perfilDemograficoCidadeJuridica,
      stateFilters: (state) => state.filters,
    }),
    infoCidade() {
      const infoCidadeArray = orderBy(this.tipoPessoa === 'F' ? this.stateInfoCidadeFisica : this.stateInfoCidadeJuridica, 'NUM_CLIENTES_CADASTRADOS', 'desc')
      if (infoCidadeArray.length > 9) {
        const othersTotal = infoCidadeArray.splice(9).reduce((total, object) => {
          return total + object['NUM_CLIENTES_CADASTRADOS']
        }, 0)
        infoCidadeArray.push({
          DES_CIDADE_SN: 'Outros',
          NUM_CLIENTES_CADASTRADOS: othersTotal,
        })
      }
      const totalCadastros = infoCidadeArray.reduce((total, current) => total + current['NUM_CLIENTES_CADASTRADOS'], 0)

      return infoCidadeArray.map((object) => {
        if (object['DES_CIDADE_SN'] === '') {
          object['DES_CIDADE_SN'] = 'NÃO INFORMADO'
        }
        object['PORCENTAGEM'] = (object['NUM_CLIENTES_CADASTRADOS'] / totalCadastros) * 100
        return object
      })
    },
  },
  methods: {
    getDataToExport() {
      const infoCidadeArray = this.tipoPessoa === 'F' ? this.stateInfoCidadeFisica : this.stateInfoCidadeJuridica
      const exportData = {
        headers: ['Cidade', 'Estado', 'Pais', 'Clientes'],
        rows: infoCidadeArray.map((data) => [data.DES_CIDADE_SN, data.DES_ESTADO_SN, data.DES_PAIS, data.NUM_CLIENTES_CADASTRADOS]),
      }
      return exportData
    },
  },
}
</script>

<style lang="scss" scoped>
.chart-container {
  display: flex;
  flex-direction: column;
  padding: 16px;
  margin: 16px 0;
  .container-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
}
</style>
